export default "__VITE_ASSET__9588e91a__"